export const MASTER_ROUTES = {
  index: {
    path: 'master/*',
    to: '/master/source',
  },
  source: {
    path: 'source',
    to: '/master/source',
  },
  addSource: {
    path: 'source/*',
    to: '/master/source/add',
  },
  loanType: {
    path: 'loan-type',
    to: '/master/loan-type',
  },
  addLoanType: {
    path: 'loan-type/*',
    to: '/master/loan-type/add',
  },
  user: {
    path: 'user',
    to: '/master/user',
  },
  updateSource: {
    path: 'source/updateSource/*',
    to: '/master/source/updateSource',
  },
  fundAccount: {
    path: 'fundaccount/*',
    to: '/master/fundaccount',
  },
  dedupe: {
    path: 'dedupe/*',
    to: '/master/dedupe',
  },
  applevelConfig: {
    path: 'applevelConfig/*',
    to: '/master/applevelconfig',
  },
  serviceMappConfig: {
    path: 'serviceMappConfig/*',
    to: '/master/serviceMappConfig',
  },
  callbackConfig: {
    path: 'callbackConfig/*',
    to: '/master/callbackConfig',
  },
  updatefundaccountSource: {
    path: 'fundaccount/updatefundaccount/*',
    to: '/master/fundaccount/updatefundaccount',
  },
  addfundaccount: {
    path: 'fundaccount/addfundaccount/*',
    to: '/master/fundaccount/addfundaccount',
  },
};
